/**
 * Parses tag IDs from a URL query parameter string.
 * Splits by comma, trims whitespace, converts to integers, filters out invalid values, and sorts.
 *
 * @param tagIdsParam - The comma-separated string of tag IDs from the URL (e.g., "1,2,3" or " 1 , 2 , 3 ")
 * @returns An array of sorted, valid tag IDs, or an empty array if the parameter is null/undefined
 */
export const parseTagIdsFromUrl = (tagIdsParam: string | null): number[] => {
  if (!tagIdsParam) {
    return [];
  }

  return tagIdsParam
    .split(',')
    .map((id) => parseInt(id, 10))
    .filter((id) => !isNaN(id))
    .sort((a, b) => a - b);
};
